export enum EJournalRoute {
  NEWS = '/journal/news',
  MAIN = '/journal',
  PUBLICATION = '/journal/publication',
  PUBLICATION_ITEM = '/journal/publication/:publicationSlug',
  TAG = '/journal/tag/:tagId',
  RUBRIC = '/journal/rubric/:rubricId',
  SEARCH = '/journal/search',
}
